export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel[PermissionLevel["Guest"] = 0] = "Guest";
    PermissionLevel[PermissionLevel["Admin"] = 1] = "Admin";
})(PermissionLevel || (PermissionLevel = {}));
